"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Panel = void 0;
var _material = require("@mui/material");
var _mui = require("tss-react/mui");
var _jsxRuntime = require("react/jsx-runtime");
const useStyles = (0, _mui.makeStyles)()(theme => ({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    // border: `1px solid ${theme.palette.divider}`,
    height: '100%',
    background: theme.palette.background.default,
    boxShadow: theme.shadows[4],
    '& > *': {
      boxSizing: 'border-box'
    }
  },
  header: {
    flex: `0 0 ${theme.spacing(5)}`,
    flexBasis: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: theme.shadows[4],
    color: theme.palette.text.primary,
    background: theme.palette.grey[200],
    // Ensure panel header is above content
    zIndex: 100
  },
  titlesContainer: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
  },
  titlesContainerWithIcon: {
    paddingLeft: theme.spacing(1)
  },
  titleIcon: {
    flex: '0 0 auto'
  },
  titles: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1),
    overflow: 'hidden'
  },
  title: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  actions: {
    display: 'flex'
  },
  body: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column'
  }
}));
const Panel = ({
  titleIcon = null,
  titleIconTooltipText = '',
  title = null,
  headerActions = null,
  children,
  dataTestId = '',
  headerTestId = '',
  classes: classesProp
}) => {
  const {
    classes,
    cx
  } = useStyles(null, {
    props: {
      classes: classesProp
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Paper, {
    className: classes.root,
    elevation: 0,
    square: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      className: classes.header,
      "data-testid": headerTestId,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: cx(classes.titlesContainer, {
          [classes.titlesContainerWithIcon]: titleIcon !== undefined
        }),
        children: [titleIcon !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
          className: classes.titleIcon,
          title: titleIconTooltipText,
          children: titleIcon
        }), title !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.titles,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            className: classes.title,
            variant: "subtitle2",
            color: "inherit",
            gutterBottom: false,
            children: title
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes.actions,
        children: headerActions
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.body,
      "data-testid": dataTestId,
      children: children
    })]
  });
};
exports.Panel = Panel;
var _default = exports.default = Panel;
//# sourceMappingURL=index.js.map